// extracted by mini-css-extract-plugin
export default {"assigned":"styles-module__assigned__src-labstep-web-components-EntityUser-Table-_vYjE5","container":"styles-module__container__src-labstep-web-components-EntityUser-Table-_CDNpL"};